import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AttachIcon from '@wix/da-ds/pkg/Icons/16x16/Attach';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './FileUploadPrompt.scss';

interface Props {}

const FileUploadPrompt: FC<Props> = () => {
  const { t } = useTranslation();
  return (
    <span className={s['root']}>
      <AttachIcon size={IconSize.SMALLER} />{' '}
      <span className={s['attach-text']}>
        {t('contactUs.fileUpload.attach')}
      </span>{' '}
      <span className={s['size-hint']}>
        {t('contactUs.fileUpload.maxSize')}
      </span>
    </span>
  );
};

FileUploadPrompt.displayName = 'FileUploadPrompt';

export default FileUploadPrompt;
